/**
 * nuke.js — "Nuke 5-PIN": dopo N PIN errati consecutivi (se abilitato),
 * cancella TUTTO localmente + tomba il sigil server-side → l'app torna a
 * "Nullum mai installato".
 *
 * Opt-in: flag locale `nullum.nukeEnabled`. Default OFF.
 * Difesa anti-coercizione: chi ti forza il telefono e prova PIN a caso
 * (>=5) distrugge l'accesso; tu recuperi con le 24 parole (che non hai
 * dato al coercitore).
 */

import { callFn } from './firebase';
import { wipeKeys } from './keys';
import { clearSession } from './storage';
import { clearLocalBackup, clearLastSigil, resetLocalAttempts } from './pinCrypto';

const NUKE_KEY = 'nullum.nukeEnabled.v1';

export function isNukeEnabled() {
  try { return localStorage.getItem(NUKE_KEY) === '1'; } catch { return false; }
}
export function setNukeEnabled(on) {
  try {
    if (on) localStorage.setItem(NUKE_KEY, '1');
    else localStorage.removeItem(NUKE_KEY);
  } catch {}
}

/**
 * Esegue il nuke completo. Best-effort: ogni step e' protetto, perche'
 * l'obiettivo e' "non lasciare traccia" anche se qualche call fallisce.
 *
 * @param {string} sigil - il sigil da tombare server-side (se possibile)
 */
export async function executeNuke(sigil) {
  // 1. Tomba server-side (richiede auth anon valida; best-effort)
  try {
    if (sigil) await callFn('tombMySigil')({ sigil });
  } catch (e) { /* ignora: procediamo comunque con il wipe locale */ }

  // 2. Wipe locale totale
  try { await wipeKeys(); } catch {}
  try { clearSession(); } catch {}
  try { clearLocalBackup(); } catch {}
  try { clearLastSigil(); } catch {}
  try { resetLocalAttempts(); } catch {}

  // 3. Pulizia localStorage residua marcata nullum.*
  try {
    const toRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith('nullum.')) toRemove.push(k);
    }
    for (const k of toRemove) localStorage.removeItem(k);
  } catch {}

  // 4. Pulizia caches + SW (come "svuota tutto") best-effort
  try {
    if (typeof caches !== 'undefined' && caches.keys) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k).catch(() => {})));
    }
  } catch {}
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister().catch(() => {})));
    }
  } catch {}
}
